import * as tslib_1 from "tslib";
import { Components } from "./decorators/components";
import "./polyfills";
import "./scss/main.scss";
import { AccoladesCarousel } from "./components/accolades-carousel/accolades-carousel.component";
import { AccoladesCarouselItem } from "./components/accolades-carousel-item/accolades-carousel-item.component";
import { AccoladesListBlocks } from "./components/accolades-list-blocks/accolades-list-blocks.component";
import { AccoladesListSimple } from "./components/accolades-list-simple/accolades-list-simple.component";
import { Accordion } from "./components/accordion/accordion.component";
import { AccordionVersionTwo } from "./components/accordion-version-two/accordion-version-two.component";
import { AdditionalRequirements } from "./components/additional-requirements/additional-requirements.component";
import { AddOn } from "./components/add-on/add-on.component";
import { AddOnInsights } from "./components/add-on-insights/add-on-insights.component";
import { Address } from "./components/address/address.component";
import { AdvancedSearch } from "./components/advanced-search/advanced-search.component";
import { ApplyNow } from "./components/apply-now/apply-now.component";
import { ArticleCombo } from "./components/article-combo/article-combo.component";
import { ArticleComboItem } from "./components/article-combo-item/article-combo-item.component";
import { ArticleComboLargeImages } from "./components/article-combo-large-images/article-combo-large-images.component";
import { ArticleFilter } from "./components/article-filter/article-filter.component";
import { ArticlePageImageCarousel } from "./components/article-page-image-carousel/article-page-image-carousel.component";
import { ArticlePageImageCarouselItem } from "./components/article-page-image-carousel-item/article-page-image-carousel-item.component";
import { ArticlePageNewsIntro } from "./components/article-page-news-intro/article-page-news-intro.component";
import { ArticlePageVideoCarousel } from "./components/article-page-video-carousel/article-page-video-carousel.component";
import { ArticlePageVideoCarouselItem } from "./components/article-page-video-carousel-item/article-page-video-carousel-item.component";
import { ArticlePodcast } from "./components/article-podcast/article-podcast.component";
import { ArtworkTile } from "./components/artwork-tile/artwork-tile.component";
import { AtmBranchLocator } from "./components/atm-branch-locator/atm-branch-locator.component";
import { Attachments } from "./components/attachments/attachments.component";
import { BannerBlueSmall } from "./components/banner-blue-small/banner-blue-small.component";
import { BannerBlueSmallItem } from "./components/banner-blue-small-item/banner-blue-small-item.component";
import { BannerHeroBlueFloatee } from "./components/banner-hero-blue-floatee/banner-hero-blue-floatee.component";
import { BannerHeroBlueFloateeItem } from "./components/banner-hero-blue-floatee-item/banner-hero-blue-floatee-item.component";
import { BannerHeroBlueSmallLogos } from "./components/banner-hero-blue-small-logos/banner-hero-blue-small-logos.component";
import { BannerHeroBlueSmallLogosItem } from "./components/banner-hero-blue-small-logos-item/banner-hero-blue-small-logos-item.component";
import { BannerHeroImageFull } from "./components/banner-hero-image-full/banner-hero-image-full.component";
import { BannerHeroImageFullItem } from "./components/banner-hero-image-full-item/banner-hero-image-full-item.component";
import { BannerMidPageFullWidth } from "./components/banner-mid-page-full-width/banner-mid-page-full-width.component";
import { BannerMidPageFullWidthItem } from "./components/banner-mid-page-full-width-item/banner-mid-page-full-width-item.component";
import { BannerMidPageVideo } from "./components/banner-mid-page-video/banner-mid-page-video.component";
import { BannerMidPageWhite } from "./components/banner-mid-page-white/banner-mid-page-white.component";
import { BannerMidPageWhiteItem } from "./components/banner-mid-page-white-item/banner-mid-page-white-item.component";
import { BannerThreeStepPromo } from "./components/banner-three-step-promo/banner-three-step-promo.component";
import { Bizconnect } from "./components/bizconnect/bizconnect.component";
import { BranchLocator } from "./components/branch-locator/branch-locator.component";
import { BranchLocatorItem } from "./components/branch-locator-item/branch-locator-item.component";
import { Breadcrumbs } from "./components/breadcrumbs/breadcrumbs.component";
import { BrowserDetection } from "./components/browser-detection/browser-detection.component";
import { Button } from "./components/button/button.component";
import { CalculatorForm } from "./components/calculator-form/calculator-form.component";
import { CalculatorItem } from "./components/calculator-item/calculator-item.component";
import { Calculators } from "./components/calculators/calculators.component";
import { CalculatorModals } from "./components/calculator-modals/calculator-modals.component";
import { CalculatorUgandaCarFinance } from "./components-uganda/calculator-uganda-car-finance/calculator-uganda-car-finance.component";
import { CalculatorUgandaPersonalLoan } from "./components-uganda/calculator-uganda-personal-loan/calculator-uganda-personal-loan.component";
import { CallMeBack } from "./components/call-me-back/call-me-back.component";
import { CampaignComponents } from "./components/campaign-components/campaign-components.component";
import { CampaignComponentsItem } from "./components/campaign-components-item/campaign-components-item.component";
import { CampaignsEditor } from "./components/campaigns-editor/campaigns-editor.component";
import { Carousel } from "./components/carousel/carousel.component";
import { CarouselArticleList } from "./components/carousel-article-list/carousel-article-list.component";
import { CarouselArticleListItem } from "./components/carousel-article-list-item/carousel-article-list-item.component";
import { CarouselArticleRelatedMediaFilesItem } from "./components/carousel-article-related-media-files-item/carousel-article-related-media-files-item.component";
import { CarouselArticleSmall } from "./components/carousel-article-small/carousel-article-small.component";
import { CarouselArticleSmallItem } from "./components/carousel-article-small-item/carousel-article-small-item.component";
import { CarouselFullwidth } from "./components/carousel-fullwidth/carousel-fullwidth.component";
import { CarouselFullwidthItem } from "./components/carousel-fullwidth-item/carousel-fullwidth-item.component";
import { CarouselItem } from "./components/carousel-item/carousel-item.component";
import { CategoryFaq } from "./components/category-faq/category-faq.component";
import { ChatBot } from "./components/chat-bot/chat-bot.component";
import { Comparison } from "./components/comparison/comparison.component";
import { ComparisonExchange } from "./components/comparison-exchange/comparison-exchange.component";
import { ContactAccordionSingle } from "./components/contact-accordion-single/contact-accordion-single.component";
import { ContactCountryAccordions } from "./components/contact-country-accordions/contact-country-accordions.component";
import { ContactTile2CountryIndivStack } from "./components/contact-tile2-country-indiv-stack/contact-tile2-country-indiv-stack.component";
import { ContactTile3CountryIndivStack } from "./components/contact-tile3-country-indiv-stack/contact-tile3-country-indiv-stack.component";
import { ContactUs } from "./components/contact-us/contact-us.component";
import { ContactUsItem } from "./components/contact-us-item/contact-us-item.component";
import { ContentCard } from "./components/content-card/content-card.component";
import { ContentCardItem } from "./components/content-card-item/content-card-item.component";
import { ContentCards } from "./components/content-cards/content-cards.component";
import { ContentCardStack } from "./components/content-card-stack/content-card-stack.component";
import { ContentDisplayCardsIconsWithImage } from "./components/content-display-cards-icons-with-image/content-display-cards-icons-with-image.component";
import { ContentDisplayCardsWithIconsOrTitle } from "./components/content-display-cards-with-icons-or-title/content-display-cards-with-icons-or-title.component";
import { ContentDisplayWithNoIconsAndImage } from "./components/content-display-with-no-icons-and-image/content-display-with-no-icons-and-image.component";
import { ContentFocusDisplays } from "./components/content-focus-displays/content-focus-displays.component";
import { ContentListStack } from "./components/content-list-stack/content-list-stack.component";
import { CookiePolicy } from "./components/cookie-policy/cookie-policy.component";
import { CountrySelector } from "./components/country-selector/country-selector.component";
import { CrossSell } from "./components/cross-sell/cross-sell.component";
import { CrossSellItem } from "./components/cross-sell-item/cross-sell-item.component";
import { CtaComponents } from "./components/cta-components/cta-components.component";
import { CtaWithImage } from "./components/cta-with-image/cta-with-image.component";
import { DealsBannerSmallLogos } from "./components/deals-banner-small-logos/deals-banner-small-logos.component";
import { DealsBannerSmallLogosItem } from "./components/deals-banner-small-logos-item/deals-banner-small-logos-item.component";
import { DealsBlueBlockAddOn } from "./components/deals-blue-block-add-on/deals-blue-block-add-on.component";
import { DealsFeature } from "./components/deals-feature/deals-feature.component";
import { DealsList } from "./components/deals-list/deals-list.component";
import { DealsListFilterYear } from "./components/deals-list-filter-year/deals-list-filter-year.component";
import { DealsListItem } from "./components/deals-list-item/deals-list-item.component";
import { DetailedProductCard } from "./components/detailed-product-card/detailed-product-card.component";
import { DetailedProductCardExchange } from "./components/detailed-product-card-exchange/detailed-product-card-exchange.component";
import { Enquiry } from "./components/enquiry/enquiry.component";
import { EventCard } from "./components/event-card/event-card.component";
import { EventList } from "./components/event-list/event-list.component";
import { EventListFilterYearTopic } from "./components/event-list-filter-year-topic/event-list-filter-year-topic.component";
import { EventListX2 } from "./components/event-list-x2/event-list-x2.component";
import { EventTile } from "./components/event-tile/event-tile.component";
import { FeatureBadge } from "./components/feature-badge/feature-badge.component";
import { FileDownloadWithImage } from "./components/file-download-with-image/file-download-with-image.component";
import { FileListFilterCategory } from "./components/file-list-filter-category/file-list-filter-category.component";
import { FileListFilterNone } from "./components/file-list-filter-none/file-list-filter-none.component";
import { FileListFilterTopic } from "./components/file-list-filter-topic/file-list-filter-topic.component";
import { FileListFilterYear } from "./components/file-list-filter-year/file-list-filter-year.component";
import { FilterBuilder } from "./components/filter-builder/filter-builder.component";
import { FollowMediaIcons } from "./components/follow-media-icons/follow-media-icons.component";
import { FooterContainer } from "./components/footer/footer.component";
import { FormBuilder } from "./components/form-builder/form-builder.component";
import { FormCheckEligibilityBusiness } from "./components/form-check-eligibility-business/form-check-eligibility-business.component";
import { FormCheckEligibilityBusinessStrataAccount } from "./components/form-check-eligibility-business-strata-account/form-check-eligibility-business-strata-account.component";
import { FormCheckEligibilityOptimumBankAccount } from "./components/form-check-eligibility-optimum-bank-account/form-check-eligibility-optimum-bank-account.component";
import { FormCheckEligibilityPlatinumOptimumBankAccount } from "./components/form-check-eligibility-platinum-optimum-bank-account/form-check-eligibility-platinum-optimum-bank-account.component";
import { FormCheckEligibilitySavingsAccount } from "./components/form-check-eligibility-savings-account/form-check-eligibility-savings-account.component";
import { FormCheckEligibilitySeafarerBankAccount } from "./components/form-check-eligibility-seafarer-bank-account/form-check-eligibility-seafarer-bank-account.component";
import { FormContainer } from "./components/form-container/form-container.component";
import { FormContainerFields } from "./components/form-container-fields/form-container-fields.component";
import { FormContainerWizard } from "./components/form-container-wizard/form-container-wizard.component";
import { FormItemBusinessCashSolutionsLead } from "./components/form-item-business-cash-solutions-lead/form-item-business-cash-solutions-lead.component";
import { FormItemCmbEligibilityBusiness } from "./components/form-item-cmb-eligibility-business/form-item-cmb-eligibility-business.component";
import { FormItemCmbEligibilityFeedback } from "./components/form-item-cmb-eligibility-feedback/form-item-cmb-eligibility-feedback.component";
import { FormItemCmbEligibilityNeedHelp } from "./components/form-item-cmb-eligibility-need-help/form-item-cmb-eligibility-need-help.component";
import { FormItemCmbEligibilityPersonal } from "./components/form-item-cmb-eligibility-personal/form-item-cmb-eligibility-personal.component";
import { FormItemNigeriaAccountEnquiry } from "./components/form-item-nigeria-account-enquiry/form-item-nigeria-account-enquiry.component";
import { FormItemNigeriaFeedback } from "./components/form-item-nigeria-feedback/form-item-nigeria-feedback.component";
import { FormItemNigeriaNeedHelp } from "./components/form-item-nigeria-need-help/form-item-nigeria-need-help.component";
import { FullPageImageBanner } from "./components/full-page-image-banner/full-page-image-banner.component";
import { FullPageVideoBanner } from "./components/full-page-video-banner/full-page-video-banner.component";
import { GenericUnsubscribeForm } from "./components/generic-unsubscribe-form/generic-unsubscribe-form.component";
import { GetTheAppBanner } from "./components/get-the-app-banner/get-the-app-banner.component";
import { GlossaryBuild } from "./components/glossary-build/glossary-build.component";
import { Header } from "./components/header/header.component";
import { HeaderV2 } from "./components/header-v2/header-v2.component";
import { HeaderBannerVideo } from "./components/header-banner-video/header-banner-video.component";
import { HeroBanner } from "./components/hero-banner/hero-banner.component";
import { HeroBannerItem } from "./components/hero-banner-item/hero-banner-item.component";
import { HeroBannerItemCol } from "./components/hero-banner-item-col/hero-banner-item-col.component";
import { HeroBannerItemFull } from "./components/hero-banner-item-full/hero-banner-item-full.component";
import { HorizontalButtons } from "./components/horizontal-buttons/horizontal-buttons.component";
import { HorizontalButtonsItem } from "./components/horizontal-buttons-item/horizontal-buttons-item.component";
import { HowToGuide } from "./components/how-to-guide/how-to-guide.component";
import { Icon } from "./components/icon/icon.component";
import { ImageCarousel } from "./components/image-carousel/image-carousel.component";
import { ImageCarouselItem } from "./components/image-carousel-item/image-carousel-item.component";
import { ImageFullWithText } from "./components/image-full-with-text/image-full-with-text.component";
import { ImageRelatedImageStack } from "./components/image-related-image-stack/image-related-image-stack.component";
import { ImageWithLargeTextLeft } from "./components/image-with-large-text-left/image-with-large-text-left.component";
import { ImageWithLargeTextRight } from "./components/image-with-large-text-right/image-with-large-text-right.component";
import { ImageWithText } from "./components/image-with-text/image-with-text.component";
import { ImageWithTextBlock } from "./components/image-with-text-block/image-with-text-block.component";
import { InfographicPage } from "./components/infographic-page/infographic-page.component";
import { InfographicPageBluebox } from "./components/infographic-page-bluebox/infographic-page-bluebox.component";
import { InfographicPageCenter } from "./components/infographic-page-center/infographic-page-center.component";
import { InfographicPageLandscape } from "./components/infographic-page-landscape/infographic-page-landscape.component";
import { InfographicPageNoblurb } from "./components/infographic-page-noblurb/infographic-page-noblurb.component";
import { InterestRates } from "./components/interest-rates/interest-rates.component";
import { Lifestyle } from "./components/lifestyle/lifestyle.component";
import { LifestyleItem } from "./components/lifestyle-item/lifestyle-item.component";
import { Link } from "./components/link/link.component";
import { ListOfLinks } from "./components/list-of-links/list-of-links.component";
import { ListOfNumbers } from "./components/list-of-numbers/list-of-numbers.component";
import { LogoCarousel } from "./components/logo-carousel/logo-carousel.component";
import { LogoCarouselItem } from "./components/logo-carousel-item/logo-carousel-item.component";
import { Map } from "./components/map/map.component";
import { MarketRates } from "./components/market-rates/market-rates.component";
import { NeedsGoals } from "./components/needs-goals/needs-goals.component";
import { NeedsGoalsItem } from "./components/needs-goals-item/needs-goals-item.component";
import { Newsletter } from "./components/newsletter/newsletter.component";
import { OnpageCountrySelector } from "./components/onpage-country-selector/onpage-country-selector.component";
import { OpenAppStore } from "./components/open-app-store/open-app-store.component";
import { OurCampaigns } from "./components/our-campaigns/our-campaigns.component";
import { OurCampaignsGrid } from "./components/our-campaigns-grid/our-campaigns-grid.component";
import { OurCampaignsItem } from "./components/our-campaigns-item/our-campaigns-item.component";
import { PageIntro } from "./components/page-intro/page-intro.component";
import { PageIntroArticle } from "./components/page-intro-article/page-intro-article.component";
import { Pagination } from "./components/pagination/pagination.component";
import { Podcast } from "./components/podcast/podcast.component";
import { PodcastRelatedPodcastStack } from "./components/podcast-related-podcast-stack/podcast-related-podcast-stack.component";
import { PollSurvey } from "./components/poll-survey/poll-survey.component";
import { PressReleases } from "./components/press-releases/press-releases.component";
import { ProductCard } from "./components/product-card/product-card.component";
import { ProductFilter } from "./components/product-filter/product-filter.component";
import { ProductFilterDropdown } from "./components/product-filter-dropdown/product-filter-dropdown.component";
import { ProductOffering } from "./components/product-offering/product-offering.component";
import { ProductOfferingExchange } from "./components/product-offering-exchange/product-offering-exchange.component";
import { ProductOfferingSlider } from "./components/product-offering-slider/product-offering-slider.component";
import { ProductOfferingSliderExchange } from "./components/product-offering-slider-exchange/product-offering-slider-exchange.component";
import { ProfileList } from "./components/profile-list/profile-list.component";
import { ProfileListCarousel } from "./components/profile-list-carousel/profile-list-carousel.component";
import { ProfileListCarouselItem } from "./components/profile-list-carousel-item/profile-list-carousel-item.component";
import { ProfileListItem } from "./components/profile-list-item/profile-list-item.component";
import { ProfilePageEnhancement } from "./components/profile-page-enhancement/profile-page-enhancement.component";
import { ProfileTile } from "./components/profile-tile/profile-tile.component";
import { PromotionalBanner } from "./components/promotional-banner/promotional-banner.component";
import { PromotionalBannerItem } from "./components/promotional-banner-item/promotional-banner-item.component";
import { RateTileFullWidth } from "./components/rate-tile-full-width/rate-tile-full-width.component";
import { ReportIntro } from "./components/report-intro/report-intro.component";
import { ReportingSecuritisation } from "./components/reporting-securitisation/reporting-securitisation.component";
import { ResourceLibrary } from "./components/resource-library/resource-library.component";
import { ResponsiveImage } from "./components/responsive-image/responsive-image.component";
import { RichTextModal } from "./components/rich-text-modal/rich-text-modal.component";
import { ScriptImage } from "./components/script-image/script-image.component";
import { Search } from "./components/search/search.component";
import { SearchResults } from "./components/search-results/search-results.component";
import { SearchResultsItem } from "./components/search-results-item/search-results-item.component";
import { SelfService } from "./components/self-service/self-service.component";
import { SelfServiceItem } from "./components/self-service-item/self-service-item.component";
import { Share } from "./components/share/share.component";
import { ShareIconsBanner } from "./components/share-icons-banner/share-icons-banner.component";
import { ShareIconsHorizontal } from "./components/share-icons-horizontal/share-icons-horizontal.component";
import { ShareIconsLeft } from "./components/share-icons-left/share-icons-left.component";
import { ShareIconsRight } from "./components/share-icons-right/share-icons-right.component";
import { ShoppingPromo } from "./components/shopping-promo/shopping-promo.component";
import { SigninModule } from "./components/signin-module/signin-module.component";
import { SitemapComponent } from "./components/sitemap/sitemap.component";
import { SocialFeeds } from "./components/social-feeds/social-feeds.component";
import { SupportingContent } from "./components/supporting-content/supporting-content.component";
import { SupportingContentCard } from "./components/supporting-content-card/supporting-content-card.component";
import { SupportingContentItem } from "./components/supporting-content-item/supporting-content-item.component";
import { SupportingDetailCard } from "./components/supporting-detail-card/supporting-detail-card.component";
import { SwitchToBusiness } from "./components/switch-to-business/switch-to-business.component";
import { SwitchToStandardBank } from "./components/switch-to-standard-bank/switch-to-standard-bank.component";
import { TabItem } from "./components/tab-item/tab-item.component";
import { TableContext } from "./components/table-context/table-context.component";
import { TablePopup } from "./components/table-popup/table-popup.component";
import { TablePopupChecklist } from "./components/table-popup-checklist/table-popup-checklist.component";
import { Tabs } from "./components/tabs/tabs.component";
import { TabsFaqs } from "./components/tabs-faqs/tabs-faqs.component";
import { TabsStandalone } from "./components/tabs-standalone/tabs-standalone.component";
import { Testimonials } from "./components/testimonials/testimonials.component";
import { TimelineVertical } from "./components/timeline-vertical/timeline-vertical.component";
import { Ucount } from "./components/ucount/ucount.component";
import { Unsubscribe } from "./components/unsubscribe/unsubscribe.component";
import { UnsubscribeBasic } from "./components/unsubscribe-basic/unsubscribe-basic.component";
import { ValueProposition } from "./components/value-proposition/value-proposition.component";
import { ValuePropositionItem } from "./components/value-proposition-item/value-proposition-item.component";
import { Video } from "./components/video/video.component";
import { VideoCarousel } from "./components/video-carousel/video-carousel.component";
import { VideoCarouselItem } from "./components/video-carousel-item/video-carousel-item.component";
import { VideoRelatedVideoStack } from "./components/video-related-video-stack/video-related-video-stack.component";
import { WantToMenu } from "./components/want-to-menu/want-to-menu.component";
import { RichText } from "./components/rich-text/rich-text.component";
import { NewsletterManage } from "./components/newsletter-manage/newsletter-manage.component";
import { NewsletterSubscribe } from "./components/newsletter-subscribe/newsletter-subscribe.component";
import { NewsletterUnsubscribe } from "./components/newsletter-unsubscribe/newsletter-unsubscribe.component";
import { NewProcess } from "./components/new-process/new-process.component";
import { VerticalScroller } from "./components/vertical-scroller/vertical-scroller.component";
import { DataExtractionPoll } from "./components/data-extraction-poll/data-extraction-poll.component";
import { BannerPromoOverlay } from "./components/banner-promo-overlay/banner-promo-overlay.component";
import { FormCheckEligibilityPersonalLoans } from "./components/form-check-eligibility-personal-loans/form-check-eligibility-personal-loans.component";
import { FormCheckEligibilityStructuredProducts } from "./components/form-check-eligibility-structured-products/form-check-eligibility-structured-products.component";
import { CookieBot } from "./components/cookie-bot/cookie-bot.component";
import { HowToGuideVertical } from "./components/how-to-guide-vertical/how-to-guide-vertical.component";
import { Library } from "./components/library/library.component";
import { CalculatorZimbabweVafCalculator } from "./components-zimbabwe/calculator-zimbabwe-vaf-calculator/calculator-zimbabwe-vaf-calculator.component";
import { QuoteTile } from "./components/quote-tile/quote-tile.component";
import { CalculatorKenyaBusinessLoan } from "./components-kenya/calculator-kenya-business-loan/calculator-kenya-business-loan.component";
import { ProfileTileItem } from "./components/profile-tile-item/profile-tile-item.component";
import { CalculatorGhanaBusinessLoan } from "./components-ghana/calculator-ghana-business-loan/calculator-ghana-business-loan.component";
import { CalculatorNamibiaBusinessLoan } from "./components-namibia/calculator-namibia-business-loan/calculator-namibia-business-loan.component";
import { AddOnGetAppQrcode } from "./components/add-on-get-app-qrcode/add-on-get-app-qrcode.component";
import { FormItemBusinessLendingVafCmbV2 } from "./components-wpbbsa/form-item-business-lending-vaf-cmb-v2/form-item-business-lending-vaf-cmb-v2.component";
import { FormItemBusinessLendingVafCmbV3 } from "./components-wpbbsa/form-item-business-lending-vaf-cmb-v3/form-item-business-lending-vaf-cmb-v3.component";
import { AddOnGetAppQrcodeSlider } from "./components/add-on-get-app-qrcode-slider/add-on-get-app-qrcode-slider.component";
import { CalculatorZimbabweBusinessLoan } from "./components-zimbabwe/calculator-zimbabwe-business-loan/calculator-zimbabwe-business-loan.component";
import { CalculatorUgandaBusinessLoan } from "./components-uganda/calculator-uganda-business-loan/calculator-uganda-business-loan.component";
import { CalculatorZambiaBusinessLoan } from "./components-zambia/calculator-zambia-business-loan/calculator-zambia-business-loan.component";
import { CareersSearchComponent } from "./components/careers-search-component/careers-search-component.component";
import { CareersSavedComponent } from "./components/careers-saved-component/careers-saved-component.component";
import { CareersDetailComponent } from "./components/careers-detail-component/careers-detail-component.component";
import { CareersFeaturedComponent } from "./components/careers-featured-component/careers-featured-component.component";
import { NigeriaStockbrokingPriceList } from "./components-nigeria/nigeria-stockbroking-price-list/nigeria-stockbroking-price-list.component";
import { CalculatorNigeriaBusinessLoan } from "./components-nigeria/calculator-nigeria-business-loan/calculator-nigeria-business-loan.component";
import { CalculatorAngolaBusinessLoan } from "./components-angola/calculator-angola-business-loan/calculator-angola-business-loan.component";
import { PosDeviceListing } from "./components/pos-device-listing/pos-device-listing.component";
import { CalculatorNigeriaPersonalLoan } from "./components-nigeria/calculator-nigeria-personal-loan/calculator-nigeria-personal-loan.component";
import { CalculatorZimbabwePersonalLoan } from "./components-zimbabwe/calculator-zimbabwe-personal-loan/calculator-zimbabwe-personal-loan.component";
import { CalculatorAngolaPersonalLoan } from "./components-angola/calculator-angola-personal-loan/calculator-angola-personal-loan.component";
import { FormItemNigeriaPensionFeedback } from "./components-nigeria/form-item-nigeria-pension-feedback/form-item-nigeria-pension-feedback.component";
import { CalculatorAngolaPersonalLoanPortuguese } from "./components-angola/calculator-angola-personal-loan-portuguese/calculator-angola-personal-loan-portuguese.component";
import { LogosWithOverlayTabs } from "./components/logos-with-overlay-tabs/logos-with-overlay-tabs.component";
import { CalculatorLesothoBusinessLoan } from "./components-lesotho/calculator-lesotho-business-loan/calculator-lesotho-business-loan.component";
import { CalculatorEswatiniBusinessLoan } from "./components-eswatini/calculator-eswatini-business-loan/calculator-eswatini-business-loan.component";
import { CalculatorBotswanaBusinessLoan } from "./components-botswana/calculator-botswana-business-loan/calculator-botswana-business-loan.component";
import { CalculatorTanzaniaBusinessLoan } from "./components-tanzania/calculator-tanzania-business-loan/calculator-tanzania-business-loan.component";
import { CalculatorMalawiBusinessLoan } from "./components-malawi/calculator-malawi-business-loan/calculator-malawi-business-loan.component";
import { NigeriaStockbrokingMarketSummary } from "./components-nigeria/nigeria-stockbroking-market-summary/nigeria-stockbroking-market-summary.component";
import { ArticleHeroBanner } from "./components/article-hero-banner/article-hero-banner.component";
import { CalculatorAngolaBusinessLoanPortuguese } from "./components-angola/calculator-angola-business-loan-portuguese/calculator-angola-business-loan-portuguese.component";
import { DealsHeroBanner } from "./components/deals-hero-banner/deals-hero-banner.component";
import { CareerSearchComponent } from "./components-career/career-search-component/career-search-component.component";
import { CareerDetailComponent } from "./components-career/career-detail-component/career-detail-component.component";
import { CareerSavedComponent } from "./components-career/career-saved-component/career-saved-component.component";
import { CareerProgrammeComponent } from "./components-career/career-programme-component/career-programme-component.component";
import { CareerFeaturedComponent } from "./components-career/career-featured-component/career-featured-component.component";
import { FormItemAngolaSalesforce } from "./components-angola/form-item-angola-salesforce/form-item-angola-salesforce.component";
import { QouteCardV2 } from "./components/qoute-card-v2/qoute-card-v2.component";
import { TimelineVerticalMobileHorizontal } from "./components/timeline-vertical-mobile-horizontal/timeline-vertical-mobile-horizontal.component";
import { SearchResultsMainDisplay } from "./components/search-results-main-display/search-results-main-display.component";
import { SearchResultsMainDisplayItem } from "./components/search-results-main-display-item/search-results-main-display-item.component";
import { CalculatorZimbabweHouseholdInsurance } from "./components-zimbabwe/calculator-zimbabwe-household-insurance/calculator-zimbabwe-household-insurance.component";
import { CalculatorZimbabweMotorInsurance } from "./components-zimbabwe/calculator-zimbabwe-motor-insurance/calculator-zimbabwe-motor-insurance.component";
import { BannerHeroImageFullNoCarousel } from "./components/banner-hero-image-full-no-carousel/banner-hero-image-full-no-carousel.component";
import { CalculatorUgandaHomeLoanAffordability } from "./components-uganda/calculator-uganda-home-loan-affordability/calculator-uganda-home-loan-affordability.component";
import { ManageAccessToReport } from "./components/manage-access-to-report/manage-access-to-report.component";
import { CalculatorEswatiniPersonalLoan } from "./components-eswatini/calculator-eswatini-personal-loan/calculator-eswatini-personal-loan.component";
import { CalculatorNamibiaVaf } from "./components-namibia/calculator-namibia-vaf/calculator-namibia-vaf.component";
import { HowToGuideV3 } from "./components/how-to-guide-v3/how-to-guide-v3.component";
import { CalculatorKenyaVaf } from "./components-kenya/calculator-kenya-vaf/calculator-kenya-vaf.component";
import { BannerLoginLinks } from "./components/banner-login-links/banner-login-links.component";
import { TableContextV2 } from "./components/table-context-v2/table-context-v2.component";
import { FormItemTradeChinaEbook } from "./components-wpbbsa/form-item-trade-china-ebook/form-item-trade-china-ebook.component";
import { BcbProductWizard } from "./components/bcb-product-wizard/bcb-product-wizard.component";
// import { TickerTape } from "./components/ticker-tape/ticker-tape.component";
import { InternationalPayment } from "./components/international-payment/international-payment.component";
import { FormItemNigeriaBlueBlossom } from "./components-nigeria/form-item-nigeria-blue-blossom/form-item-nigeria-blue-blossom.component";
import { InteractiveShareChart } from "./components/interactive-share-chart/interactive-share-chart.component";
import { SbgDynamicSharePrice } from "./components/sbg-dynamic-share-price/sbg-dynamic-share-price.component";
import { SbgDividendCalculator } from "./components/sbg-dividend-calculator/sbg-dividend-calculator.component";
import { CalculatorKenyaHomeloan } from "./components-kenya/calculator-kenya-homeloan/calculator-kenya-homeloan.component";
import { FormItemFleetThreeSixty } from "./components/form-item-fleet-three-sixty/form-item-fleet-three-sixty.component";
import { SbgDynamicSharePriceHistorical } from "./components/sbg-dynamic-share-price-historical/sbg-dynamic-share-price-historical.component";
import { CountrySelectorOnlineBanking } from "./components/country-selector-online-banking/country-selector-online-banking.component";
import { CalculatorNigeriaHomeLoanAffordability } from "./components-nigeria/calculator-nigeria-home-loan-affordability/calculator-nigeria-home-loan-affordability.component";
import { UiKitSb3 } from "./components/ui-kit-sb3/ui-kit-sb3.component";
import { SbgSensAnnouncements } from "./components/sbg-sens-announcements/sbg-sens-announcements.component";
import { FormItemMailFormV4 } from "./components-wpbbsa/form-item-mail-form-v4/form-item-mail-form-v4.component";
import { CalculatorMalawiPersonalLoan } from "./components-malawi/calculator-malawi-personal-loan/calculator-malawi-personal-loan.component";
import { QuizQa } from "./components/quiz-qa/quiz-qa.component";
import { FxCalculator } from "./components/fx-calculator/fx-calculator.component";
import { ContentListWithCategory } from "./components/content-list-with-category/content-list-with-category.component";
import { ContentFocusNumbers } from "./components/content-focus-numbers/content-focus-numbers.component";
import { DebtorFinance } from "./components/debtor-finance/debtor-finance.component";
import { Greetings } from "./components/greetings/greetings.component";
import { LegalPractitionerForm } from "./components/legal-practitioner-form/legal-practitioner-form.component";
import { WholesaleFinanceForm } from "./components/wholesale-finance-form/wholesale-finance-form.component";
import { SbgSensAnnouncementsEquity } from "./components/sbg-sens-announcements-equity/sbg-sens-announcements-equity.component";
import { BannerHeroImageFullPageWithVideo } from "./components/banner-hero-image-full-page-with-video/banner-hero-image-full-page-with-video.component";
import { BannerHeroImageFullWithPageTitle } from "./components/banner-hero-image-full-with-page-title/banner-hero-image-full-with-page-title.component";
import { BannerMidPageImageFullDownloadAppLinks } from "./components/banner-mid-page-image-full-download-app-links/banner-mid-page-image-full-download-app-links.component";
import { Podcasts } from "./components/podcasts/podcasts.component";
import { ValuePropositionList } from "./components/value-proposition-list/value-proposition-list.component";
import { AccoladesListV2 } from "./components/accolades-list-v2/accolades-list-v2.component";
import { GhanaTickerTape } from "./components/ghana-ticker-tape/ghana-ticker-tape.component";
import { BannerMidPageImageFullWithVideo } from "./components/banner-mid-page-image-full-with-video/banner-mid-page-image-full-with-video.component";
import { OurFootprint } from "./components/our-footprint/our-footprint.component";
import { SbgDebtAnnouncements } from "./components/sbg-debt-announcements/sbg-debt-announcements.component";
import { ImageLinkV2 } from "./components/image-link-v2/image-link-v2.component";
import { AccoladesListV3 } from "./components/accolades-list-v3/accolades-list-v3.component";
import { CalculatorBotswanaVaf } from "./components-botswana/calculator-botswana-vaf/calculator-botswana-vaf.component";
import { CalculatorBotswanaAffordabilityHomeLoan } from "./components-botswana/calculator-botswana-affordability-home-loan/calculator-botswana-affordability-home-loan.component";
import { CalculatorBotswanaHomeLoanRepayment } from "./components-botswana/calculator-botswana-home-loan-repayment/calculator-botswana-home-loan-repayment.component";
import { CalculatorKenyaMoneyMarket } from "./components-kenya/calculator-kenya-money-market/calculator-kenya-money-market.component";
import { ProductCsOfferingComparativeView } from "./components/product-cs-offering-comparative-view/product-cs-offering-comparative-view.component";
import { CalculatorBotswanaPersonalLoan } from "./components-botswana/calculator-botswana-personal-loan/calculator-botswana-personal-loan.component";
import { CalculatorLesothoPersonalLoan } from "./components-lesotho/calculator-lesotho-personal-loan/calculator-lesotho-personal-loan.component";
import { CalculatorLesothoAffordabilityHomeLoan } from "./components-lesotho/calculator-lesotho-affordability-home-loan/calculator-lesotho-affordability-home-loan.component";
import { FormItemCmbEligibilityPersonalApply } from "./components/form-item-cmb-eligibility-personal-apply/form-item-cmb-eligibility-personal-apply.component";
import { OnpageProductWizard } from "./components/onpage-product-wizard/onpage-product-wizard.component";
// pbbsa
import { CalculatorPersonalloansV2Form } from "./components-wpbbsa/calculator-personalloans-v2-form/calculator-personalloans-v2-form.component";
import { CalculatorPersonalloansV2Item } from "./components-wpbbsa/calculator-personalloans-v2-item/calculator-personalloans-v2-item.component";
import { CalculatorsBusinessloansV2 } from "./components-wpbbsa/calculators-businessloans-v2/calculators-businessloans-v2.component";
import { CalculatorsBusinessloansV3 } from "./components-wpbbsa/calculators-businessloans-v3/calculators-businessloans-v3.component";
import { CalculatorsPersonalloansAmortisation } from "./components-wpbbsa/calculators-personalloans-amortisation/calculators-personalloans-amortisation.component";
import { CalculatorsPersonalloansV2 } from "./components-wpbbsa/calculators-personalloans-v2/calculators-personalloans-v2.component";
import { CalculatorsSmartgeyser } from "./components-wpbbsa/calculators-smartgeyser/calculators-smartgeyser.component";
import { CalculatorsStudentLoans } from "./components-wpbbsa/calculators-student-loans/calculators-student-loans.component";
import { CalculatorsVafAccessFinance } from "./components-wpbbsa/calculators-vaf-access-finance/calculators-vaf-access-finance.component";
import { FormContainerRelatedLinks } from "./components-wpbbsa/form-container-related-links/form-container-related-links.component";
import { FormContainerRelatedLinksStudentLoans } from "./components-wpbbsa/form-container-related-links-student-loans/form-container-related-links-student-loans.component";
import { FormItemAccessQuote } from "./components-wpbbsa/form-item-access-quote/form-item-access-quote.component";
import { FormItemAccessQuotePc } from "./components-wpbbsa/form-item-access-quote-pc/form-item-access-quote-pc.component";
import { FormItemAccessQuoteUpl } from "./components-wpbbsa/form-item-access-quote-upl/form-item-access-quote-upl.component";
import { FormItemAgriBusinessFinanceFarmers } from "./components-wpbbsa/form-item-agri-business-finance-farmers/form-item-agri-business-finance-farmers.component";
import { FormItemBizFlexLoanCallback } from "./components-wpbbsa/form-item-biz-flex-loan-callback/form-item-biz-flex-loan-callback.component";
import { FormItemBlApplyNow } from "./components-wpbbsa/form-item-bl-apply-now/form-item-bl-apply-now.component";
import { FormItemBlApplyNowPc } from "./components-wpbbsa/form-item-bl-apply-now-pc/form-item-bl-apply-now-pc.component";
import { FormItemBlApplyNowPcV2 } from "./components-wpbbsa/form-item-bl-apply-now-pc-v2/form-item-bl-apply-now-pc-v2.component";
import { FormItemBusiness48hourDeposit } from "./components-wpbbsa/form-item-business-48hour-deposit/form-item-business-48hour-deposit.component";
import { FormItemBusinessAwards } from "./components-wpbbsa/form-item-business-awards/form-item-business-awards.component";
import { FormItemBusinessBca } from "./components-wpbbsa/form-item-business-bca/form-item-business-bca.component";
import { FormItemBusinessBcaV2 } from "./components-wpbbsa/form-item-business-bca-v2/form-item-business-bca-v2.component";
import { FormItemBusinessBcaV3 } from "./components-wpbbsa/form-item-business-bca-v3/form-item-business-bca-v3.component";
import { FormItemBusinessBewellForm } from "./components-wpbbsa/form-item-business-bewell-form/form-item-business-bewell-form.component";
import { FormItemBusinessBizlaunch } from "./components-wpbbsa/form-item-business-bizlaunch/form-item-business-bizlaunch.component";
import { FormItemBusinessBizlaunchV2 } from "./components-wpbbsa/form-item-business-bizlaunch-v2/form-item-business-bizlaunch-v2.component";
import { FormItemBusinessCashSolutions } from "./components-wpbbsa/form-item-business-cash-solutions/form-item-business-cash-solutions.component";
import { FormItemBusinessCashSolutionsV2 } from "./components-wpbbsa/form-item-business-cash-solutions-v2/form-item-business-cash-solutions-v2.component";
import { FormItemBusinessCommercialPropertyInsurance } from "./components-wpbbsa/form-item-business-commercial-property-insurance/form-item-business-commercial-property-insurance.component";
import { FormItemBusinessCommercialPropertyInsuranceV2 } from "./components-wpbbsa/form-item-business-commercial-property-insurance-v2/form-item-business-commercial-property-insurance-v2.component";
import { FormItemBusinessLendingCmbV2Form } from "./components-wpbbsa/form-item-business-lending-cmb-v2-form/form-item-business-lending-cmb-v2-form.component";
import { FormItemBusinessLendingCmbV3Form } from "./components-wpbbsa/form-item-business-lending-cmb-v3-form/form-item-business-lending-cmb-v3-form.component";
import { FormItemBusinessLendingCmbV4Form } from "./components-wpbbsa/form-item-business-lending-cmb-v4-form/form-item-business-lending-cmb-v4-form.component";
import { FormItemBusinessCorporateCardsCmb } from "./components-wpbbsa/form-item-business-corporate-cards-cmb/form-item-business-corporate-cards-cmb.component";
import { FormItemBusinessLendingCmb } from "./components-wpbbsa/form-item-business-lending-cmb/form-item-business-lending-cmb.component";
import { FormItemBusinessInsuranceCmb } from "./components-wpbbsa/form-item-business-insurance-cmb/form-item-business-insurance-cmb.component";
import { FormItemBusinessLendingVafCmb } from "./components-wpbbsa/form-item-business-lending-vaf-cmb/form-item-business-lending-vaf-cmb.component";
import { FormItemBusinessNtbTermLoan } from "./components-wpbbsa/form-item-business-ntb-term-loan/form-item-business-ntb-term-loan.component";
import { FormItemBusinessNtbTermLoanV2 } from "./components-wpbbsa/form-item-business-ntb-term-loan-v2/form-item-business-ntb-term-loan-v2.component";
import { FormItemClearscore } from "./components-wpbbsa/form-item-clearscore/form-item-clearscore.component";
import { FormItemMotodata } from "./components-wpbbsa/form-item-motodata/form-item-motodata.component";
import { FormItemComplimentsAndComplaints } from "./components-wpbbsa/form-item-compliments-and-complaints/form-item-compliments-and-complaints.component";
import { FormItemCorporateCards } from "./components-wpbbsa/form-item-corporate-cards/form-item-corporate-cards.component";
import { FormItemBusinessCorporateCardsCmbV2 } from "./components-wpbbsa/form-item-business-corporate-cards-cmb-v2/form-item-business-corporate-cards-cmb-v2.component";
import { FormItemDeceasedEstatesCmb } from "./components-wpbbsa/form-item-deceased-estates-cmb/form-item-deceased-estates-cmb.component";
import { FormItemDfcBusiness } from "./components-wpbbsa/form-item-dfc-business/form-item-dfc-business.component";
import { FormItemDfcBusinessV2 } from "./components-wpbbsa/form-item-dfc-business-v2/form-item-dfc-business-v2.component";
import { FormItemDfcBusinessV3 } from "./components-wpbbsa/form-item-dfc-business-v3/form-item-dfc-business-v3.component";
import { FormItemDfcPersonal } from "./components-wpbbsa/form-item-dfc-personal/form-item-dfc-personal.component";
import { FormItemEmployerValueBanking } from "./components-wpbbsa/form-item-employer-value-banking/form-item-employer-value-banking.component";
import { FormItemFleetManagementReportLostStolenCard } from "./components-wpbbsa/form-item-fleet-management-report-lost-stolen-card/form-item-fleet-management-report-lost-stolen-card.component";
import { FormItemFlexibleFuneralPlanCmb } from "./components-wpbbsa/form-item-flexible-funeral-plan-cmb/form-item-flexible-funeral-plan-cmb.component";
import { FormItemFlexibleFuneralPlanCmbV2 } from "./components-wpbbsa/form-item-flexible-funeral-plan-cmb-v2/form-item-flexible-funeral-plan-cmb-v2.component";
import { FormItemFlexiFuneralQuote } from "./components-wpbbsa/form-item-flexi-funeral-quote/form-item-flexi-funeral-quote.component";
import { FormItemFnTemporaryResidentBanking } from "./components-wpbbsa/form-item-fn-temporary-resident-banking/form-item-fn-temporary-resident-banking.component";
import { FormItemGapAssistCmb } from "./components-wpbbsa/form-item-gap-assist-cmb/form-item-gap-assist-cmb.component";
import { FormItemGenericForm } from "./components/form-item-generic-form/form-item-generic-form.component";
import { FormItemHealthSectorCmb } from "./components-wpbbsa/form-item-health-sector-cmb/form-item-health-sector-cmb.component";
import { FormItemHomeServicesVas } from "./components-wpbbsa/form-item-home-services-vas/form-item-home-services-vas.component";
import { FormItemHsApplyNow } from "./components-wpbbsa/form-item-hs-apply-now/form-item-hs-apply-now.component";
import { FormItemHsPropertyInspections } from "./components-wpbbsa/form-item-hs-property-inspections/form-item-hs-property-inspections.component";
import { FormItemHsVasStatistics } from "./components-wpbbsa/form-item-hs-vas-statistics/form-item-hs-vas-statistics.component";
import { FormItemInstalmentRelief } from "./components-wpbbsa/form-item-instalment-relief/form-item-instalment-relief.component";
import { FormItemInsurancePersonal } from "./components-wpbbsa/form-item-insurance-personal/form-item-insurance-personal.component";
import { FormItemInsurancePersonalV2 } from "./components-wpbbsa/form-item-insurance-personal-v2/form-item-insurance-personal-v2.component";
import { FormItemInsurancePersonalV3 } from "./components-wpbbsa/form-item-insurance-personal-v3/form-item-insurance-personal-v3.component";
import { FormItemInsurancePersonalExternal } from "./components-wpbbsa/form-item-insurance-personal-external/form-item-insurance-personal-external.component";
import { FormItemLegalAssistCmb } from "./components-wpbbsa/form-item-legal-assist-cmb/form-item-legal-assist-cmb.component";
import { FormItemLifeCoverInsurance } from "./components-wpbbsa/form-item-life-cover-insurance/form-item-life-cover-insurance.component";
import { FormItemFlexibleLifePlan } from "./components-wpbbsa/form-item-flexible-life-plan/form-item-flexible-life-plan.component";
import { FormItemLifeCoverInsuranceV2 } from "./components-wpbbsa/form-item-life-cover-insurance-v2/form-item-life-cover-insurance-v2.component";
import { FormItemLookseeContactUs } from "./components-wpbbsa/form-item-looksee-contact-us/form-item-looksee-contact-us.component";
import { FormItemMailForm } from "./components-wpbbsa/form-item-mail-form/form-item-mail-form.component";
import { FormItemMerchantSolutions } from "./components-wpbbsa/form-item-merchant-solutions/form-item-merchant-solutions.component";
import { FormItemMvno } from "./components-wpbbsa/form-item-mvno/form-item-mvno.component";
import { FormItemMymoAccCallback } from "./components-wpbbsa/form-item-mymo-acc-callback/form-item-mymo-acc-callback.component";
import { FormItemMymoBusiness } from "./components-wpbbsa/form-item-mymo-business/form-item-mymo-business.component";
import { FormItemMymoDropOffSurvey } from "./components-wpbbsa/form-item-mymo-drop-off-survey/form-item-mymo-drop-off-survey.component";
import { FormItemMymoGbCallback } from "./components-wpbbsa/form-item-mymo-gb-callback/form-item-mymo-gb-callback.component";
import { FormItemMymoPlusCallback } from "./components-wpbbsa/form-item-mymo-plus-callback/form-item-mymo-plus-callback.component";
import { FormItemNpsCustomerSurvey } from "./components-wpbbsa/form-item-nps-customer-survey/form-item-nps-customer-survey.component";
import { FormItemPaiaRequest } from "./components-wpbbsa/form-item-paia-request/form-item-paia-request.component";
import { FormItemPayspacePayrollAndHr } from "./components-wpbbsa/form-item-payspace-payroll-and-hr/form-item-payspace-payroll-and-hr.component";
import { FormItemPermitRenewal } from "./components-wpbbsa/form-item-permit-renewal/form-item-permit-renewal.component";
import { FormItemPowerpulse } from "./components-wpbbsa/form-item-powerpulse/form-item-powerpulse.component";
import { FormItemProfessionalBanking } from "./components-wpbbsa/form-item-professional-banking/form-item-professional-banking.component";
import { FormItemReportDeathDetails } from "./components-wpbbsa/form-item-report-death-details/form-item-report-death-details.component";
import { FormItemReportDeathDetailsV2 } from "./components-wpbbsa/form-item-report-death-details-v2/form-item-report-death-details-v2.component";
import { FormItemSimplybluApply } from "./components-wpbbsa/form-item-simplyblu-apply/form-item-simplyblu-apply.component";
import { FormItemSolarLoanQuoteCmb } from "./components-wpbbsa/form-item-solar-loan-quote-cmb/form-item-solar-loan-quote-cmb.component";
import { FormItemStansure } from "./components-wpbbsa/form-item-stansure/form-item-stansure.component";
import { FormItemStudentLoansQuote } from "./components-wpbbsa/form-item-student-loans-quote/form-item-student-loans-quote.component";
import { FormItemSurvey } from "./components-wpbbsa/form-item-survey/form-item-survey.component";
import { FormItemTradeBarometer } from "./components-wpbbsa/form-item-trade-barometer/form-item-trade-barometer.component";
import { FormItemTradePointBrochure } from "./components-wpbbsa/form-item-trade-point-brochure/form-item-trade-point-brochure.component";
import { FormItemWinACar } from "./components-wpbbsa/form-item-win-a-car/form-item-win-a-car.component";
import { FormItemYouthPageModal } from "./components-wpbbsa/form-item-youth-page-modal/form-item-youth-page-modal.component";
import { MiniBasket } from "./components-wpbbsa/mini-basket/mini-basket.component";
import { LiveInterestRates } from "./components-wpbbsa/live-interest-rates/live-interest-rates.component";
import { SearchCoza } from "./components-wpbbsa/search-coza/search-coza.component";
import { WpbbsaCalculatorForm } from "./components-wpbbsa/wpbbsa-calculator-form/wpbbsa-calculator-form.component";
import { WpbbsaCalculatorFormV2 } from "./components-wpbbsa/wpbbsa-calculator-form-v2/wpbbsa-calculator-form-v2.component";
import { WpbbsaCalculatorItem } from "./components-wpbbsa/wpbbsa-calculator-item/wpbbsa-calculator-item.component";
import { WpbbsaCalculatorItemV2 } from "./components-wpbbsa/wpbbsa-calculator-item-v2/wpbbsa-calculator-item-v2.component";
import { WpbbsaCalculators } from "./components-wpbbsa/wpbbsa-calculators/wpbbsa-calculators.component";
import { WpbbsaCalculatorsV2 } from "./components-wpbbsa/wpbbsa-calculators-v2/wpbbsa-calculators-v2.component";
import { WpbbsaCalculatorModals } from "./components-wpbbsa/wpbbsa-calculator-modals/wpbbsa-calculator-modals.component";
import { WpbbsaCalculatorModalsV2 } from "./components-wpbbsa/wpbbsa-calculator-modals-v2/wpbbsa-calculator-modals-v2.component";
import { FormItemPropertyPractitionerCmb } from "./components-wpbbsa/form-item-property-practitioner-cmb/form-item-property-practitioner-cmb.component";
import { FormItemPropertyPractitionerCmbV2 } from "./components-wpbbsa/form-item-property-practitioner-cmb-v2/form-item-property-practitioner-cmb-v2.component";
import { FormItemDfcBusinessGym } from "./components-wpbbsa/form-item-dfc-business-gym/form-item-dfc-business-gym.component";
import { FormItemNewToBankCmb } from "./components-wpbbsa/form-item-new-to-bank-cmb/form-item-new-to-bank-cmb.component";
import { FormItemRegistrationAchieva } from "./components-wpbbsa/form-item-registration-achieva/form-item-registration-achieva.component";
import { FormItemScamsCardFraudCmb } from "./components-wpbbsa/form-item-scams-card-fraud-cmb/form-item-scams-card-fraud-cmb.component";
import { FormItemBusinessTradeCmb } from "./components-wpbbsa/form-item-business-trade-cmb/form-item-business-trade-cmb.component";
import { FormItemPayspacePayrollAndHrV2 } from "./components-wpbbsa/form-item-payspace-payroll-and-hr-v2/form-item-payspace-payroll-and-hr-v2.component";
import { FormItemEmployerValueBankingV2 } from "./components-wpbbsa/form-item-employer-value-banking-v2/form-item-employer-value-banking-v2.component";
import { FormItemBusinessInternationalPaymentsCmb } from "./components-wpbbsa/form-item-business-international-payments-cmb/form-item-business-international-payments-cmb.component";
import { FormItemBusinessFinancialPlanningCmb } from "./components-wpbbsa/form-item-business-financial-planning-cmb/form-item-business-financial-planning-cmb.component";
import { FormItemBusinessSwitchBankCmb } from "./components-wpbbsa/form-item-business-switch-bank-cmb/form-item-business-switch-bank-cmb.component";
import { FormItemBusinessSolarLoan } from "./components/form-item-business-solar-loan/form-item-business-solar-loan.component";
import { FormItemMailFormV2 } from "./components-wpbbsa/form-item-mail-form-v2/form-item-mail-form-v2.component";
import { FormItemMailFormV3 } from "./components-wpbbsa/form-item-mail-form-v3/form-item-mail-form-v3.component";
import { FormItemTradeBarometerV2 } from "./components-wpbbsa/form-item-trade-barometer-v2/form-item-trade-barometer-v2.component";
import { FormItemBusinessTermLoan } from "./components/form-item-business-term-loan/form-item-business-term-loan.component";
import { FormItemBlApplyNowPcV3 } from "./components-wpbbsa/form-item-bl-apply-now-pc-v3/form-item-bl-apply-now-pc-v3.component";
import { BusinessSolutionAccountants } from "./components/business-solution-accountants/business-solution-accountants.component";
import { FormItemShariaCafLoan } from "./components/form-item-sharia-caf-loan/form-item-sharia-caf-loan.component";
import { ExecutorCurrentAccount } from "./components/executor-current-account/executor-current-account.component";
import { PropertyPractitionersTrustAccount } from "./components/property-practitioners-trust-account/property-practitioners-trust-account.component";
import { AttorneyTrustAccount } from "./components/attorney-trust-account/attorney-trust-account.component";
import { FormItemBusinessGrowYourMoney } from "./components/form-item-business-grow-your-money/form-item-business-grow-your-money.component";
import { FormItemBusinessLendingPage } from "./components/form-item-business-lending-page/form-item-business-lending-page.component";
import { FormItemHomeServicesSwitch } from "./components-wpbbsa/form-item-home-services-switch/form-item-home-services-switch.component";
import { FormItemStokvelLeagueCmb } from "./components-wpbbsa/form-item-stokvel-league-cmb/form-item-stokvel-league-cmb.component";
import { FinanceCalculatorForm } from "./components/finance-calculator-form/finance-calculator-form.component";
import { FinanceCalculatorItem } from "./components/finance-calculator-item/finance-calculator-item.component";
import { FinanceCalculators } from "./components/finance-calculators/finance-calculators.component";
import { FinanceCalculatorModals } from "./components/finance-calculator-modals/finance-calculator-modals.component";
import { FinanceCalculatorCallMeBack } from "./components/finance-calculator-call-me-back/finance-calculator-call-me-back.component";
import { FormItemBusinessCreditGarageCards } from "./components/form-item-business-cards/form-item-business-cards.component";
import { FormItemTravelFuelSupplierCards } from "./components/form-item-travel-fuel-supplier-cards/form-item-travel-fuel-supplier-cards.component";
import { FormItemInsurancePersonalServicePlanForm } from "./components-wpbbsa/form-item-insurance-personal-service-plan-form/form-item-insurance-personal-service-plan-form.component";
import { FormItemMerchantSolutionsV3 } from './components/form-item-merchant-solutions-v3/form-item-merchant-solutions-v3.component';
import { FormItemShariahOverdraft } from "./components/form-item-shariah-overdraft/form-item-shariah-overdraft.component";
import { FormItemBusinessTradeClub } from "./components/form-item-business-trade-club/form-item-business-trade-club.component";
import { KasiEconomyNewRegistrationForm } from "./components/kasi-economy-new-registration-form/kasi-economy-new-registration-form.component";
import { FormItemBusinessCafNtb } from "./components/form-item-business-caf-ntb/form-item-business-caf-ntb.component";
import { FormItemFranchisingSolutions } from "./components/form-item-franchising-solutions/form-item-franchising-solutions.component";
import { FormItemTradesmen } from "./components/form-item-tradesmen/form-item-tradesmen.component";
import { WpbbsaManageAccessToReport } from "./components-wpbbsa/wpbbsa-manage-access-to-report/wpbbsa-manage-access-to-report.component";
import { FormItemWpbbsaMailForm } from "./components-wpbbsa/form-item-wpbbsa-mail-form/form-item-wpbbsa-mail-form.component";
import { FormItemBusinessPublicSectorCmb } from "./components/form-item-business-public-sector-cmb/form-item-business-public-sector-cmb.component";
import { FormItemCommercialInsurance } from "./components/form-item-commercial-insurance/form-item-commercial-insurance.component";
import { KasiSmeSummitApplication } from "./components/kasi-sme-summit-application/kasi-sme-summit-application.component";
import { FormItemAgriBusiness } from "./components/form-item-agri-business/form-item-agri-business.component";
import { MahikengSmeSummitApplication } from "./components/mahikeng-sme-summit-application/mahikeng-sme-summit-application.component";
import { NpsFeedbackEform } from "./components/nps-feedback-eform/nps-feedback-eform.component";
import { CalculatorSolarSavings } from "./components/calculator-solar-savings/calculator-solar-savings.component";
import { FinancialLiteracyMasterclass } from "./components/financial-literacy-masterclass/financial-literacy-masterclass.component";
import { InclusiveExcellenceAwards } from "./components/inclusive-excellence-awards/inclusive-excellence-awards.component";
import { FormItemBeautyBizForm } from "./components/form-item-beauty-biz-form/form-item-beauty-biz-form.component";
import { PushIspan } from "./components/push-ispan/push-ispan.component";
import { BusinessSustainability } from "./components/business-sustainability/business-sustainability.component";
import { LoanAffordabilityCalculators } from "./components/loan-affordability-calculators/loan-affordability-calculators.component";
import { CalculatorSolarSavingsTab } from "./components/calculator-solar-savings-tab/calculator-solar-savings-tab.component";
import { CalculatorVehicleFinanceTab } from "./components/calculator-vehicle-finance-tab/calculator-vehicle-finance-tab.component";
import { CalculatorAssetFinanceTab } from "./components/calculator-asset-finance-tab/calculator-asset-finance-tab.component";
var Kilimanjaro = /** @class */ (function () {
    function Kilimanjaro() {
    }
    Kilimanjaro = tslib_1.__decorate([
        Components({
            register: [
                AccoladesCarousel,
                AccoladesCarouselItem,
                AccoladesListBlocks,
                AccoladesListSimple,
                Accordion,
                Accordion,
                AccordionVersionTwo,
                AddOn,
                AddOnInsights,
                AdditionalRequirements,
                Address,
                AdvancedSearch,
                ApplyNow,
                ArticleCombo,
                ArticleComboItem,
                ArticleComboLargeImages,
                ArticleFilter,
                ArticlePageImageCarousel,
                ArticlePageImageCarouselItem,
                ArticlePageNewsIntro,
                ArticlePageVideoCarousel,
                ArticlePageVideoCarouselItem,
                ArticlePodcast,
                ArtworkTile,
                AtmBranchLocator,
                Attachments,
                BannerBlueSmall,
                BannerBlueSmallItem,
                BannerHeroBlueFloatee,
                BannerHeroBlueFloateeItem,
                BannerHeroBlueSmallLogos,
                BannerHeroBlueSmallLogosItem,
                BannerHeroImageFull,
                BannerHeroImageFullItem,
                BannerMidPageFullWidth,
                BannerMidPageFullWidthItem,
                BannerMidPageVideo,
                BannerMidPageWhite,
                BannerMidPageWhiteItem,
                BannerThreeStepPromo,
                Bizconnect,
                BranchLocator,
                BranchLocatorItem,
                Breadcrumbs,
                BrowserDetection,
                Button,
                CalculatorForm,
                CalculatorItem,
                CalculatorModals,
                CalculatorUgandaCarFinance,
                CalculatorUgandaPersonalLoan,
                Calculators,
                CallMeBack,
                CampaignComponents,
                CampaignComponentsItem,
                CampaignsEditor,
                Carousel,
                CarouselArticleList,
                CarouselArticleListItem,
                CarouselArticleRelatedMediaFilesItem,
                CarouselArticleSmall,
                CarouselArticleSmallItem,
                CarouselFullwidth,
                CarouselFullwidthItem,
                CarouselItem,
                CategoryFaq,
                ChatBot,
                Comparison,
                ComparisonExchange,
                ContactAccordionSingle,
                ContactCountryAccordions,
                ContactTile2CountryIndivStack,
                ContactTile3CountryIndivStack,
                ContactUs,
                ContactUsItem,
                ContentCard,
                ContentCardItem,
                ContentCardStack,
                ContentCards,
                ContentDisplayCardsIconsWithImage,
                ContentDisplayCardsWithIconsOrTitle,
                ContentDisplayWithNoIconsAndImage,
                ContentFocusDisplays,
                ContentListStack,
                CookiePolicy,
                CountrySelector,
                CrossSell,
                CrossSellItem,
                CtaComponents,
                CtaWithImage,
                DealsBannerSmallLogos,
                DealsBannerSmallLogosItem,
                DealsBlueBlockAddOn,
                DealsFeature,
                DealsList,
                DealsListFilterYear,
                DealsListItem,
                DetailedProductCard,
                DetailedProductCardExchange,
                Enquiry,
                EventCard,
                EventList,
                EventListFilterYearTopic,
                EventListX2,
                EventTile,
                FeatureBadge,
                FileDownloadWithImage,
                FileListFilterCategory,
                FileListFilterNone,
                FileListFilterTopic,
                FileListFilterYear,
                FilterBuilder,
                FollowMediaIcons,
                FooterContainer,
                FormBuilder,
                FormCheckEligibilityBusiness,
                FormCheckEligibilityBusinessStrataAccount,
                FormCheckEligibilityOptimumBankAccount,
                FormCheckEligibilityPlatinumOptimumBankAccount,
                FormCheckEligibilitySavingsAccount,
                FormCheckEligibilitySeafarerBankAccount,
                FormContainer,
                FormContainerFields,
                FormContainerWizard,
                FormItemBusinessCashSolutionsLead,
                FormItemCmbEligibilityBusiness,
                FormItemCmbEligibilityFeedback,
                FormItemCmbEligibilityNeedHelp,
                FormItemCmbEligibilityPersonal,
                FormItemGenericForm,
                FormItemHealthSectorCmb,
                FormItemNigeriaAccountEnquiry,
                FormItemNigeriaFeedback,
                FormItemNigeriaNeedHelp,
                FullPageImageBanner,
                FullPageVideoBanner,
                GenericUnsubscribeForm,
                GetTheAppBanner,
                GlossaryBuild,
                Header,
                HeaderV2,
                HeaderBannerVideo,
                HeroBanner,
                HeroBannerItem,
                HeroBannerItemCol,
                HeroBannerItemFull,
                HorizontalButtons,
                HorizontalButtonsItem,
                HowToGuide,
                Icon,
                ImageCarousel,
                ImageCarouselItem,
                ImageCarouselItem,
                ImageFullWithText,
                ImageRelatedImageStack,
                ImageWithLargeTextLeft,
                ImageWithLargeTextRight,
                ImageWithText,
                ImageWithTextBlock,
                InfographicPage,
                FormItemNewToBankCmb,
                FormItemRegistrationAchieva,
                FormItemScamsCardFraudCmb,
                InfographicPageBluebox,
                InfographicPageCenter,
                InfographicPageLandscape,
                InfographicPageNoblurb,
                InterestRates,
                Lifestyle,
                LifestyleItem,
                Link,
                ListOfLinks,
                ListOfNumbers,
                LogoCarousel,
                LogoCarouselItem,
                Map,
                MarketRates,
                NeedsGoals,
                NeedsGoalsItem,
                Newsletter,
                OnpageCountrySelector,
                OpenAppStore,
                OurCampaigns,
                OurCampaignsGrid,
                OurCampaignsItem,
                PageIntro,
                PageIntroArticle,
                Pagination,
                Podcast,
                PodcastRelatedPodcastStack,
                PollSurvey,
                PressReleases,
                ProductCard,
                ProductFilter,
                ProductFilterDropdown,
                ProductOffering,
                ProductOfferingExchange,
                ProductOfferingSlider,
                ProductOfferingSliderExchange,
                ProfileList,
                ProfileListCarousel,
                ProfileListCarouselItem,
                ProfileListItem,
                ProfilePageEnhancement,
                ProfileTile,
                PromotionalBanner,
                PromotionalBannerItem,
                RateTileFullWidth,
                ReportIntro,
                ReportingSecuritisation,
                ResourceLibrary,
                ResponsiveImage,
                RichTextModal,
                ScriptImage,
                Search,
                SearchResults,
                SearchResultsItem,
                SelfService,
                SelfServiceItem,
                Share,
                ShareIconsBanner,
                ShareIconsHorizontal,
                ShareIconsLeft,
                ShareIconsRight,
                ShoppingPromo,
                SigninModule,
                SitemapComponent,
                SocialFeeds,
                SupportingContent,
                SupportingContentCard,
                SupportingContentItem,
                SupportingDetailCard,
                SwitchToBusiness,
                SwitchToStandardBank,
                TabItem,
                TableContext,
                TablePopup,
                TablePopupChecklist,
                Tabs,
                TabsFaqs,
                TabsStandalone,
                Testimonials,
                TimelineVertical,
                Ucount,
                Unsubscribe,
                UnsubscribeBasic,
                ValueProposition,
                ValuePropositionItem,
                Video,
                VideoCarousel,
                VideoCarouselItem,
                VideoRelatedVideoStack,
                WantToMenu,
                RichText,
                NewsletterManage,
                NewsletterSubscribe,
                NewsletterUnsubscribe,
                NewProcess,
                VerticalScroller,
                DataExtractionPoll,
                BannerPromoOverlay,
                FormCheckEligibilityPersonalLoans,
                FormCheckEligibilityStructuredProducts,
                CookieBot,
                HowToGuideVertical,
                Library,
                CalculatorZimbabweVafCalculator,
                QuoteTile,
                CalculatorKenyaBusinessLoan,
                ProfileTileItem,
                CalculatorGhanaBusinessLoan,
                CalculatorNamibiaBusinessLoan,
                AddOnGetAppQrcode,
                AddOnGetAppQrcodeSlider,
                CalculatorZimbabweBusinessLoan,
                CalculatorUgandaBusinessLoan,
                CalculatorZambiaBusinessLoan,
                CareersSearchComponent,
                CareersSavedComponent,
                CareersDetailComponent,
                CareersFeaturedComponent,
                NigeriaStockbrokingPriceList,
                CalculatorNigeriaBusinessLoan,
                CalculatorAngolaBusinessLoan,
                PosDeviceListing,
                CalculatorNigeriaPersonalLoan,
                CalculatorZimbabwePersonalLoan,
                CalculatorAngolaPersonalLoan,
                FormItemNigeriaPensionFeedback,
                CalculatorAngolaPersonalLoanPortuguese,
                LogosWithOverlayTabs,
                CalculatorLesothoBusinessLoan,
                CalculatorEswatiniBusinessLoan,
                CalculatorBotswanaBusinessLoan,
                CalculatorTanzaniaBusinessLoan,
                CalculatorMalawiBusinessLoan,
                NigeriaStockbrokingMarketSummary,
                ArticleHeroBanner,
                CalculatorAngolaBusinessLoanPortuguese,
                DealsHeroBanner,
                CareerSearchComponent,
                CareerDetailComponent,
                CareerSavedComponent,
                CareerProgrammeComponent,
                CareerFeaturedComponent,
                FormItemAngolaSalesforce,
                QouteCardV2,
                TimelineVerticalMobileHorizontal,
                SearchResultsMainDisplay,
                SearchResultsMainDisplayItem,
                CalculatorZimbabweHouseholdInsurance,
                CalculatorZimbabweMotorInsurance,
                BannerHeroImageFullNoCarousel,
                CalculatorUgandaHomeLoanAffordability,
                ManageAccessToReport,
                CalculatorEswatiniPersonalLoan,
                TableContextV2,
                CalculatorNamibiaVaf,
                HowToGuideV3,
                CalculatorKenyaVaf,
                BannerLoginLinks,
                TableContextV2,
                BcbProductWizard,
                // TickerTape,
                FormItemNigeriaBlueBlossom,
                InteractiveShareChart,
                SbgDynamicSharePrice,
                SbgDividendCalculator,
                CalculatorKenyaHomeloan,
                SbgDynamicSharePriceHistorical,
                CountrySelectorOnlineBanking,
                CalculatorNigeriaHomeLoanAffordability,
                UiKitSb3,
                SbgSensAnnouncements,
                CalculatorMalawiPersonalLoan,
                QuizQa,
                FxCalculator,
                ContentListWithCategory,
                ContentFocusNumbers,
                Greetings,
                SbgSensAnnouncementsEquity,
                BannerHeroImageFullPageWithVideo,
                BannerHeroImageFullWithPageTitle,
                BannerMidPageImageFullDownloadAppLinks,
                Podcasts,
                ValuePropositionList,
                AccoladesListV2,
                GhanaTickerTape,
                BannerMidPageImageFullWithVideo,
                OurFootprint,
                SbgDebtAnnouncements,
                ImageLinkV2,
                AccoladesListV3,
                CalculatorBotswanaVaf,
                CalculatorBotswanaAffordabilityHomeLoan,
                CalculatorBotswanaHomeLoanRepayment,
                CalculatorKenyaMoneyMarket,
                ProductCsOfferingComparativeView,
                CalculatorBotswanaPersonalLoan,
                CalculatorLesothoPersonalLoan,
                CalculatorLesothoAffordabilityHomeLoan,
                FormItemCmbEligibilityPersonalApply,
                OnpageProductWizard,
                // pbbsa
                CalculatorPersonalloansV2Form,
                CalculatorPersonalloansV2Item,
                CalculatorsBusinessloansV2,
                CalculatorsBusinessloansV3,
                CalculatorsPersonalloansAmortisation,
                CalculatorsPersonalloansV2,
                CalculatorsStudentLoans,
                CalculatorsSmartgeyser,
                CalculatorsVafAccessFinance,
                FormContainerRelatedLinks,
                FormContainerRelatedLinksStudentLoans,
                FormItemAccessQuote,
                FormItemAccessQuotePc,
                FormItemAccessQuoteUpl,
                FormItemAgriBusinessFinanceFarmers,
                FormItemBlApplyNow,
                FormItemBlApplyNowPc,
                FormItemBlApplyNowPcV2,
                FormItemBusiness48hourDeposit,
                FormItemBizFlexLoanCallback,
                FormItemBusinessAwards,
                FormItemBusinessBca,
                FormItemBusinessBcaV2,
                FormItemBusinessBcaV3,
                FormItemBusinessBewellForm,
                FormItemBusinessBizlaunch,
                FormItemBusinessBizlaunchV2,
                FormItemBusinessCashSolutions,
                FormItemBusinessCashSolutionsV2,
                FormItemBusinessCommercialPropertyInsurance,
                FormItemBusinessCommercialPropertyInsuranceV2,
                FormItemBusinessCorporateCardsCmb,
                FormItemBusinessLendingCmb,
                FormItemBusinessInsuranceCmb,
                FormItemBusinessLendingVafCmb,
                FormItemBusinessLendingCmbV2Form,
                FormItemBusinessLendingCmbV3Form,
                FormItemBusinessLendingCmbV4Form,
                FormItemBusinessNtbTermLoan,
                FormItemBusinessNtbTermLoanV2,
                FormItemClearscore,
                FormItemMotodata,
                FormItemComplimentsAndComplaints,
                FormItemCorporateCards,
                FormItemBusinessCorporateCardsCmbV2,
                FormItemDeceasedEstatesCmb,
                FormItemDfcBusiness,
                FormItemDfcBusinessV2,
                FormItemDfcBusinessV3,
                FormItemDfcPersonal,
                FormItemEmployerValueBanking,
                FormItemFleetManagementReportLostStolenCard,
                FormItemFlexiFuneralQuote,
                FormItemFlexibleFuneralPlanCmb,
                FormItemFlexibleFuneralPlanCmbV2,
                FormItemFnTemporaryResidentBanking,
                FormItemGapAssistCmb,
                FormItemHomeServicesVas,
                FormItemHsApplyNow,
                FormItemHsPropertyInspections,
                FormItemHsVasStatistics,
                FormItemInstalmentRelief,
                FormItemInsurancePersonal,
                FormItemInsurancePersonalV2,
                FormItemInsurancePersonalV3,
                FormItemInsurancePersonalExternal,
                FormItemLegalAssistCmb,
                FormItemLifeCoverInsurance,
                FormItemFlexibleLifePlan,
                FormItemLifeCoverInsuranceV2,
                FormItemLookseeContactUs,
                FormItemMailForm,
                FormItemMerchantSolutions,
                FormItemMvno,
                FormItemMymoAccCallback,
                FormItemMymoBusiness,
                FormItemMymoDropOffSurvey,
                FormItemMymoGbCallback,
                FormItemMymoPlusCallback,
                FormItemNpsCustomerSurvey,
                FormItemPaiaRequest,
                FormItemPayspacePayrollAndHr,
                FormItemPermitRenewal,
                FormItemPowerpulse,
                FormItemProfessionalBanking,
                FormItemReportDeathDetails,
                FormItemReportDeathDetailsV2,
                FormItemBusinessLendingVafCmbV2,
                FormItemBusinessLendingVafCmbV3,
                FormItemSimplybluApply,
                FormItemSolarLoanQuoteCmb,
                FormItemStansure,
                FormItemStudentLoansQuote,
                FormItemSurvey,
                FormItemTradeBarometer,
                FormItemTradePointBrochure,
                FormItemWinACar,
                FormItemYouthPageModal,
                MiniBasket,
                LiveInterestRates,
                SearchCoza,
                WpbbsaCalculatorForm,
                WpbbsaCalculatorFormV2,
                WpbbsaCalculatorItem,
                WpbbsaCalculatorItemV2,
                WpbbsaCalculators,
                WpbbsaCalculatorsV2,
                WpbbsaCalculatorModals,
                WpbbsaCalculatorModalsV2,
                FormItemPropertyPractitionerCmb,
                FormItemPropertyPractitionerCmbV2,
                FormItemDfcBusinessGym,
                FormItemTradeChinaEbook,
                FormItemFleetThreeSixty,
                FormItemBusinessTradeCmb,
                FormItemPayspacePayrollAndHrV2,
                FormItemEmployerValueBankingV2,
                FormItemBusinessInternationalPaymentsCmb,
                FormItemBusinessFinancialPlanningCmb,
                FormItemBusinessSwitchBankCmb,
                FormItemBusinessSolarLoan,
                FormItemMailFormV2,
                FormItemMailFormV3,
                FormItemMailFormV4,
                FormItemTradeBarometerV2,
                FormItemBusinessTermLoan,
                FormItemBlApplyNowPcV3,
                BusinessSolutionAccountants,
                FormItemShariaCafLoan,
                AttorneyTrustAccount,
                ExecutorCurrentAccount,
                PropertyPractitionersTrustAccount,
                FormItemBusinessGrowYourMoney,
                FormItemBusinessLendingPage,
                FormItemHomeServicesSwitch,
                FormItemStokvelLeagueCmb,
                DebtorFinance,
                FinanceCalculatorForm,
                FinanceCalculatorItem,
                FinanceCalculators,
                FinanceCalculatorModals,
                FinanceCalculatorCallMeBack,
                LegalPractitionerForm,
                WholesaleFinanceForm,
                FormItemBusinessCreditGarageCards,
                FormItemTravelFuelSupplierCards,
                FormItemInsurancePersonalServicePlanForm,
                InternationalPayment,
                FormItemMerchantSolutionsV3,
                FormItemShariahOverdraft,
                FormItemBusinessTradeClub,
                KasiEconomyNewRegistrationForm,
                FormItemBusinessCafNtb,
                FormItemFranchisingSolutions,
                FormItemTradesmen,
                WpbbsaManageAccessToReport,
                FormItemWpbbsaMailForm,
                FormItemBusinessPublicSectorCmb,
                FormItemCommercialInsurance,
                KasiSmeSummitApplication,
                FormItemAgriBusiness,
                MahikengSmeSummitApplication,
                CalculatorSolarSavings,
                NpsFeedbackEform,
                FinancialLiteracyMasterclass,
                InclusiveExcellenceAwards,
                FormItemBeautyBizForm,
                PushIspan,
                BusinessSustainability,
                LoanAffordabilityCalculators,
                CalculatorSolarSavingsTab,
                CalculatorVehicleFinanceTab,
                CalculatorAssetFinanceTab
            ],
        })
    ], Kilimanjaro);
    return Kilimanjaro;
}());
export { Kilimanjaro };



//////////////////
// WEBPACK FOOTER
// ./app.ts
// module id = 31
// module chunks = 0